// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "15.5.20";import { commonConfig } from '@bridebook/toolbox/src/sentry/sentry-client-config';
import { FetchyError } from '@bridebook/toolbox/src/fetchy';
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  ...commonConfig,
  ignoreErrors: [
    ...(commonConfig.ignoreErrors ?? []),
    'auth/email-already-in-use',
    'auth/account-exists-with-different-credential',
  ],
  // Need to be more specific about localhost as by default it was checking the whole url for the 'localhost' string and it was attaching extra headers to the requests
  tracePropagationTargets: [/^https?:[/][/]localhost/, /^[/]/],
  integrations: [Sentry.browserTracingIntegration()],
  beforeSend(event, hint) {
    const error = hint.originalException;

    if (
      event?.exception?.values?.some((exception) =>
        exception?.value?.startsWith(
          'refusing to open IndexedDB database due to potential corruption of the IndexedDB database data; this corruption could be caused by clicking the "clear site data" button in a web browser;',
        ),
      )
    ) {
      return null;
    }

    if (error instanceof FetchyError) {
      event.contexts = {
        ...event.contexts,
        Fetchy: {
          URL: error.response?.url ?? error.endpoint,
          Code: error.code,
          Method: error.method,
          Endpoint: error.endpoint,
        },
      };

      event.fingerprint = [error.toString()];
    }

    return event;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
